import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { HomeComponent } from "../home/home.component";
import { SummaryComponent } from './summary/summary.component';
import { ConsumerComponent } from './consumer/consumer.component';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { CategoryFunctinalitesComponent } from './category-functinalites/category-functinalites.component';
import { ProductFunctinalitesComponent } from './product-functinalites/product-functinalites.component';
import { SubProductFunctinalitesComponent } from './sub-product-functinalites/sub-product-functinalites.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { TransactiondetailsComponent } from './transactiondetails/transactiondetails.component';
import { UsersComponent } from './users/users.component';


const homeroutes: Routes = [
  { path: "", redirectTo: "home/dashboard", pathMatch: "full" },
  {
    path: 'home', component: HomeComponent, children: [
      {
        path: 'dashboard',
        component: DashboardComponent, data: { Key: 'Dashboard' },
      },
      {
        path: 'summary',
        component: SummaryComponent, data: { Key: 'Dashboard' },
      },
      {
        path: 'consumer',
        component: ConsumerComponent, data: { Key: 'Consumers List' },
      },
      {
        path: 'transactions',
        component: TransactionsComponent, data: { Key: 'Transactions' },
      },
      {
        path: 'transactiondetails/:id',
        component: TransactiondetailsComponent, data: { Key: 'Transactions Details' },
      },
      {
        path: 'users',
        component: UsersComponent, data: { Key: 'Users List' },
      },
      {
        path: 'adminpanel',
        component: AdminPanelComponent, children: [
          {
            path: 'category',
            component: CategoryFunctinalitesComponent, data: { Key: 'Category' },
          },
          {
            path: 'product',
            component: ProductFunctinalitesComponent, data: { Key: 'product' },
          },
          {
            path: 'subproduct',
            component: SubProductFunctinalitesComponent, data: { Key: 'subproduct' },
          },
        ], data: { Key: 'Admin' }
      },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [CommonModule,
    RouterModule.forChild(homeroutes)
  ],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
